import ApiService from './api.service'

const PricesService = {
	getDepartments: function () {
		return ApiService.post(`/department/shop-list`);
	},
	getPrices: function () {
		return ApiService.get(`/pricing-item/list-for-pos`);
	},
	aktPricingList(id) {
		return ApiService.get(`/pricing/get-pricing-akt/${id}`)
	},
	createPrices: function (data) {
		return ApiService.post(`/pricing/create`, data);
	},
	createPricesExcel: function (data) {
		return ApiService.post(`/pricing/create/with-excel`, data);
	},
	createPricingDocForWrapped: function (data) {
		return ApiService.post(`/pricing/create-for-wh`, data);
	},
	getRegNumber: function (data) {
		return ApiService.post(`/pricing/generate-regnumber`, data);
	},
	getPricingList: function (searchForm) {
		return ApiService.post(`/pricing/list`, searchForm);
	},
	editPricing: function (id) {
		return ApiService.get(`/pricing/get/${id}`);
	},
	updatePricing: function (data) {
		return ApiService.put(`/pricing/edit/${data.id}`, data);
	},
	lastPricing(data) {
		return ApiService.post(`/pricing-item/last-price`, data);
	},
	lastPricingForWrapped(data) {
		return ApiService.post(`/pricing-item/last-wh-price`, data);
	},
	pricingItemsWithPagination(data) {

		return ApiService.post(`/pricing-item/last-price-with-pagination`, data);
	},
	pricingItemsWithPaginationSection3(data) {
		return ApiService.post(`/pricing/item-different-price`, data);
	},
	viewPricingList(docId){
		return ApiService.get(`/pricing/get-whItems/${docId}`);
	},
	pricingItemsWithPaginationSection4(data) {
		return ApiService.post(`/pricing/search/kirim-extra-cost`, data);
	},
	getItemByPrice(link) {
		return ApiService.get(`/item-balance/print/barcode/with-price${link}`)
	},
	getPendingDocPrices(data) {
		return ApiService.post(`/pricing/pending-wh-document-with-pricing`, data)
	},
	getPricingItemsWithDifferent() {
		return ApiService.post(`/pricing/item-different-price-total`, {departmentIds: []})
	}
};

export default PricesService
